module.exports = __webpack_public_path__ + "static/image/service/m/one@3x.jpg?de46c58e";